import React from 'react';
import PageSubHeader from './PageSubHeader';
import ExportNavigationButton from 'pages/DataExtraction/Navigation/ExportNavigationButton';

interface Props {
  links: {
    path: string;
    name: string;
    count?: number;
    is_active: boolean;
  }[];
  exportLink?: string;
}

const ExtractionPageSubHeader = ({ links = [], exportLink }: Props) => {
  return (
    <PageSubHeader links={links}>
      {exportLink && (
        <ExportNavigationButton
          label="Export"
          path={exportLink}
          pendoKey="det-export"
        />
      )}
    </PageSubHeader>
  );
};

export default ExtractionPageSubHeader;
